/* Pawlity · fiche IT v5 · interactions (quiz, confronto, orbite, dose, prima/dopo, pack finale, barre collante) */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function txt(root, key, val, attr) {
    $$('[' + attr + '="' + key + '"]', root).forEach(function (el) { el.textContent = val; });
  }

  /* ---------- données ---------- */
  var W = [
    { ml: '1 ml', gg: '60', eur: '0,33 €', dura: '60 giorni', need: '1–2 flaconi', pack: 'Pack Sollievo · 3 flaconi', why: 'Il ciclo completo più 3 mesi di mantenimento', price: '59,98 €', img: 'pack3', cta: 'Scegli il Pack Sollievo · 59,98 €', note: 'Sotto gli 11 kg: un contagocce pieno al giorno. Un flacone dura due mesi.', who: 'Cane piccolo' },
    { ml: '2 ml', gg: '30', eur: '0,67 €', dura: '30 giorni', need: '3 flaconi', pack: 'Pack Sollievo · 3 flaconi', why: 'Esattamente il ciclo completo', price: '59,98 €', img: 'pack3', cta: 'Scegli il Pack Sollievo · 59,98 €', note: 'Da 11 a 34 kg: due contagocce al giorno. Un flacone al mese, tre per il ciclo.', who: 'Cane medio' },
    { ml: '3 ml', gg: '20', eur: '0,90 €', dura: '20 giorni', need: '4–5 flaconi', pack: 'Pack Rinascita · 5 flaconi', why: 'Il ciclo completo per un cane grande', price: '89,97 €', img: 'pack5', cta: 'Scegli il Pack Rinascita · 89,97 €', note: 'Oltre 34 kg: tre contagocce al giorno. Un flacone dura venti giorni, cinque per il ciclo.', who: 'Cane grande' }
  ];
  var FIN = {
    1: { name: 'Pack Scoperta · 1 flacone', who: 'Per provare · 2 mesi per un cane piccolo', price: '29,99 €', old: '39,99 €', day: 'da 0,50 € al giorno', img: 'pack1', cta: 'Aggiungi al carrello · 29,99 €' },
    3: { name: 'Pack Sollievo · 3 flaconi', who: 'Il ciclo completo di 8–12 settimane · 2+1 gratis', price: '59,98 €', old: '119,97 €', day: '0,67 € al giorno per un cane medio', img: 'pack3', cta: 'Inizia il ciclo completo · 59,98 €' },
    5: { name: 'Pack Rinascita · 5 flaconi', who: 'Cane grande, o due cani in casa · 3+2 gratis', price: '89,97 €', old: '199,95 €', day: '0,90 € al giorno per un cane grande', img: 'pack5', cta: 'Aggiungi al carrello · 89,97 €' }
  };
  var ICO = {
    loop: 'M4 12a8 8 0 0114-5l2 2M20 12a8 8 0 01-14 5l-2-2',
    moon: 'M20 14.5A8 8 0 019.5 4a7 7 0 1010.5 10.5z',
    ear: 'M8 20V9a4 4 0 118 0c0 3-2 4-2 7M8 20h3',
    caps: 'M12 2a7 7 0 017 7v6a7 7 0 01-14 0V9a7 7 0 017-7zM5 12h14',
    shield: 'M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z'
  };

  /* ---------- dose (come si usa) ---------- */
  var dose = $('[data-pwf-dose]');
  var weight = 1;
  function setWeight(i, fromQuiz) {
    weight = i;
    if (!dose) return;
    var w = W[i];
    txt(dose, 'ml', w.ml, 'data-d'); txt(dose, 'gg', w.gg, 'data-d'); txt(dose, 'eur', w.eur, 'data-d');
    txt(dose, 'note', w.note, 'data-d'); txt(dose, 'who', w.who, 'data-d');
    $$('[data-w]', dose).forEach(function (b) { b.classList.toggle('on', Number(b.getAttribute('data-w')) === i); });
  }
  if (dose) {
    $$('[data-w]', dose).forEach(function (b) { b.addEventListener('click', function () { setWeight(Number(b.getAttribute('data-w'))); }); });
  }

  var quizPack = 3;
  /* ---------- quiz ---------- */
  var quiz = $('[data-pwf-quiz]');
  if (quiz) {
    var qs = 1, a1 = {}, a2 = -1, a3 = {}, a4 = -1;
    var steps = $$('.pwf-qstep', quiz), res = $('.pwf-qres', quiz), nav = $('.pwf-qnav', quiz);
    var dots = $$('.pwf-dot', quiz), label = $('[data-q-label]', quiz), nextBtn = $('[data-q-next]', quiz), backBtn = $('[data-q-back]', quiz);
    var labels = ['Domanda 1 di 4', 'Domanda 2 di 4', 'Domanda 3 di 4', 'Domanda 4 di 4', 'Risultato'];
    var imgs = quiz.getAttribute('data-imgs') ? JSON.parse(quiz.getAttribute('data-imgs')) : {};
    function paint() {
      steps.forEach(function (s) { s.hidden = Number(s.getAttribute('data-step')) !== qs; });
      res.hidden = qs !== 5; nav.hidden = qs === 5;
      dots.forEach(function (d, i) { d.classList.toggle('on', i < qs); });
      label.textContent = labels[qs - 1];
      nextBtn.textContent = qs === 4 ? 'Vedi il risultato' : 'Avanti';
      $$('.pwf-qstep[data-step="1"] .pwf-qchip', quiz).forEach(function (c, i) { c.classList.toggle('on', !!a1[i]); });
      $$('.pwf-qstep[data-step="2"] .pwf-qchip', quiz).forEach(function (c, i) { c.classList.toggle('on', a2 === i); });
      $$('.pwf-qstep[data-step="3"] .pwf-qchip', quiz).forEach(function (c, i) { c.classList.toggle('on', !!a3[i]); });
      $$('.pwf-qstep[data-step="4"] .pwf-qchip', quiz).forEach(function (c, i) { c.classList.toggle('on', a4 === i); });
    }
    function result() {
      var drugs = !!a3[0] || !!a3[1], p;
      if (drugs) p = { name: 'Il circolo dei farmaci', ico: ICO.loop, text: 'Funziona, poi torna: hai già visto il film. Apoquel e cortisone spengono l’allarme, non chiudono la crepa nella barriera. Pawlity si affianca ai farmaci dal primo giorno, senza sospendere niente.' };
      else if (a1[0]) p = { name: 'Notti difficili', ico: ICO.moon, text: 'Il grattamento notturno è il primo segnale di una barriera che non tiene più. Ed è anche il primo che sparisce: di solito tra la seconda e la terza settimana.' };
      else if (a1[2]) p = { name: 'Orecchie e barriera', ico: ICO.ear, text: 'Le otiti che tornano sono la stessa barriera che cede nel punto più umido. Non si risolvono con l’ennesima pulizia: si lavora dall’interno.' };
      else if (a3[4]) p = { name: 'Il collagene sbagliato', ico: ICO.caps, text: 'Compresse e polveri arrivano alla pelle al 20–30%. Non era il meccanismo a non funzionare, era il formato. In gocce, estratto a freddo, ne arriva fino al 98%.' };
      else p = { name: 'Barriera stanca', ico: ICO.shield, text: 'Pancia rossa, zampe leccate, pelo che si dirada: non sono problemi diversi. È la stessa barriera cutanea che ha smesso di filtrare gli allergeni.' };
      var durs = ['Sei all’inizio: è il momento migliore per intervenire, prima che la crepa si allarghi.', 'Dopo mesi la barriera ha bisogno del ciclo completo: 8–12 settimane, senza saltare giorni.', 'Dopo anni la barriera ha bisogno del ciclo completo, e poi di una dose di mantenimento.'];
      var wi = a4 >= 0 ? a4 : 1, w = W[wi];
      quizPack = w.img === 'pack5' ? 5 : 3;
      txt(res, 'name', p.name, 'data-r'); txt(res, 'text', p.text, 'data-r'); txt(res, 'dur', a2 >= 0 ? durs[a2] : durs[1], 'data-r');
      txt(res, 'dose', w.ml + ' al giorno', 'data-r'); txt(res, 'dura', w.dura, 'data-r'); txt(res, 'need', w.need, 'data-r');
      txt(res, 'pack', w.pack, 'data-r'); txt(res, 'why', w.why, 'data-r'); txt(res, 'price', w.price, 'data-r'); txt(res, 'cta', w.cta, 'data-r');
      var ip = $('[data-r="ico"]', res); if (ip) ip.setAttribute('d', p.ico);
      var im = $('img[data-r="img"]', res); if (im && imgs[w.img]) im.src = imgs[w.img];
      if (a4 >= 0) { setWeight(a4, true); if (a4 === 2 && window.pwfSetPack) window.pwfSetPack(5); }
    }
    steps.forEach(function (s) {
      var n = Number(s.getAttribute('data-step'));
      $$('.pwf-qchip', s).forEach(function (c, i) {
        c.addEventListener('click', function () {
          if (n === 1) a1[i] = !a1[i]; else if (n === 2) a2 = i; else if (n === 3) a3[i] = !a3[i]; else a4 = i;
          paint();
        });
      });
    });
    nextBtn.addEventListener('click', function () { qs = Math.min(5, qs + 1); if (qs === 5) result(); paint(); });
    backBtn.addEventListener('click', function () { qs = Math.max(1, qs - 1); paint(); });
    var reset = $('[data-q-reset]', quiz);
    if (reset) reset.addEventListener('click', function () { qs = 1; a1 = {}; a2 = -1; a3 = {}; a4 = -1; paint(); });
    paint();
  }

  /* ---------- confronto ---------- */
  var vs = $('[data-pwf-vs]');
  if (vs) {
    $$('[data-vs]', vs).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-vs');
        $$('[data-vs]', vs).forEach(function (x) { x.classList.toggle('on', x === b); });
        $$('[data-vs-panel]', vs).forEach(function (p) { p.hidden = p.getAttribute('data-vs-panel') !== k; });
      });
    });
  }

  /* ---------- orbite ---------- */
  var orbit = $('[data-pwf-orbit]');
  if (orbit) {
    var card = $('[data-pwf-ing]');
    $$('.pwf-oi button', orbit).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.pwf-oi button', orbit).forEach(function (x) { x.classList.toggle('on', x === b); });
        orbit.classList.add('paused');
        if (card) {
          txt(card, 'name', b.getAttribute('data-name'), 'data-i'); txt(card, 'mg', b.getAttribute('data-mg'), 'data-i'); txt(card, 'role', b.getAttribute('data-role'), 'data-i');
          var im = $('img', card); if (im) im.src = b.getAttribute('data-img');
        }
      });
    });
  }

  /* ---------- prima / dopo ---------- */
  var ba = $('[data-pwf-ba]');
  if (ba) {
    var rng = $('input[type="range"]', ba), before = $('.pwf-ba-before', ba), line = $('.pwf-ba-line', ba), knob = $('.pwf-ba-knob', ba);
    function slide() {
      var v = Number(rng.value);
      before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
      line.style.left = v + '%'; knob.style.left = v + '%';
      $$('.pwf-cal.before', ba).forEach(function (c) { c.classList.toggle('off', v < 35); });
      $$('.pwf-cal.after', ba).forEach(function (c) { c.classList.toggle('off', v > 65); });
    }
    ['input', 'change'].forEach(function (e) { rng.addEventListener(e, slide); });
    slide();
  }

  /* ---------- pack finale + barre collante ---------- */
  var fin = $('[data-pwf-fin]'), sticky = $('#pwf-sticky');
  var pack = 3;
  window.pwfSetPack = function (n) {
    pack = n;
    if (fin) {
      var f = FIN[n], imgs2 = fin.getAttribute('data-imgs') ? JSON.parse(fin.getAttribute('data-imgs')) : {};
      ['name', 'who', 'price', 'old', 'day', 'cta'].forEach(function (k) { txt(fin, k, f[k], 'data-f'); });
      var im = $('img[data-f="img"]', fin); if (im && imgs2[f.img]) im.src = imgs2[f.img];
      var badge = $('.pwf-badge', fin); if (badge) badge.hidden = n !== 3;
      $$('[data-pack]', fin).forEach(function (b) { b.classList.toggle('on', Number(b.getAttribute('data-pack')) === n); });
    }
    if (sticky) { txt(sticky, 'name', FIN[n].name, 'data-s'); txt(sticky, 'price', FIN[n].price, 'data-s'); }
  };
  if (fin) $$('[data-pack]', fin).forEach(function (b) { b.addEventListener('click', function () { window.pwfSetPack(Number(b.getAttribute('data-pack'))); }); });
  window.pwfSetPack(3);
  if (sticky) {
    var anchor = $('#acquista') || $('.product-form');
    var ticking = false;
    function check() {
      ticking = false;
      if (!anchor) return;
      var r = anchor.getBoundingClientRect();
      var finR = fin ? fin.getBoundingClientRect() : null;
      var show = r.top < -200 && !(finR && finR.top < window.innerHeight && finR.bottom > 0);
      sticky.classList.toggle('show', show);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }
  /* ---------- flèches du mur de chiens (desktop, 19 oct.) ---------- */
  var wall = $('.pwf-wall');
  if (wall) {
    $$('[data-wall-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = $('.pwf-wc', wall); var step = card ? card.getBoundingClientRect().width + 16 : 320;
        wall.scrollBy({ left: (b.getAttribute('data-wall-nav') === 'prev' ? -1 : 1) * step, behavior: 'smooth' });
      });
    });
  }
  /* ---------- ajout diretto al carrello : palier Kaching + bouton du thème (19 oct.) ---------- */
  var ADDING = false;
  window.pwfAddPack = function (n) {
    var want = { 1: /SCOPERTA/i, 3: /SOLLIEVO/i, 5: /RINASCITA/i }[n];
    var bars = $$('.kaching-bundles__bar'), bar = null;
    bars.forEach(function (b) { if (!bar && want && want.test(b.textContent || '')) bar = b; });
    if (!bar) bar = bars[{ 1: 0, 3: 1, 5: 2 }[n]] || null;
    var atc = $('.product-form__submit');
    if (!bar || !atc || atc.disabled || ADDING) return false;
    ADDING = true;
    var lab = $('label.kaching-bundles__bar-container', bar) || bar;
    lab.click();
    setTimeout(function () {
      var r = $('input[type="radio"]', bar); if (r && !r.checked) r.click();
      setTimeout(function () { atc.click(); ADDING = false; }, 150);
    }, 300);
    return true;
  };
  $$('[data-pwf-add]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var v = el.getAttribute('data-pwf-add');
      var n = v === 'current' ? pack : v === 'quiz' ? quizPack : Number(v);
      if (window.pwfAddPack(n)) e.preventDefault();
    });
  });
  setWeight(1);
})();
/* boucles vidéo : lecture seulement quand visible (19 oct.) */
(function(){var vids=document.querySelectorAll('video[data-pwf-autoplay]');if(!vids.length||!('IntersectionObserver' in window))return;var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.intersectionRatio>=0.5){v.muted=true;var p=v.play();if(p&&p.catch){p.catch(function(){});}}else{v.pause();}});},{threshold:[0,0.5]});Array.prototype.forEach.call(vids,function(v){io.observe(v);});})();
